import React from 'react';

import { DialogComponent } from '@/components/DialogComponent';
import { ModalProps } from '@/components/Modals/types';

import { ContextualGroupsConfigType, VisibilitySettingsValueType } from '../../types';
import { RestrictedVisibilitySettingsTabType } from './components/RestrictedVisibilitySettingsGroupsTab/types';

export const enum ModalTabsId {
  GROUPS = 'GROUPS',
  USERS = 'USERS',
}

export type ModalTabsType = {
  value: ModalTabsId;
  label: string;
  renderer: (value: RestrictedVisibilitySettingsTabType) => React.ReactNode;
};

export type BaseRestrictedVisibilitySettingsModalProps = VisibilitySettingsValueType & {
  onClose: () => void;
  allowGroupCsvImport?: boolean;
  header?: ModalProps['header'];
  action?: Partial<ModalProps['action']>;
  tabs: ModalTabsType[];
  classes?: React.ComponentProps<typeof DialogComponent>['classes'] & { tabContainer?: string };
};

export type RestrictedVisibilitySettingsModalProps = {
  contextualGroupsConfig?: ContextualGroupsConfigType;
  action?: BaseRestrictedVisibilitySettingsModalProps['action'];
  header?: BaseRestrictedVisibilitySettingsModalProps['header'];
  classes?: BaseRestrictedVisibilitySettingsModalProps['classes'];
  allowGroupCsvImport?: boolean;
} & VisibilitySettingsValueType &
  Pick<BaseRestrictedVisibilitySettingsModalProps, 'onClose'>;
